module.exports = __webpack_public_path__ + "static/media/MariaRamirez.b198dda7.png";